













































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Sheti extends Vue {
  @Prop()
  private tongue: any;
  private shese: any[] = ["淡", "淡红", "红", "暗红", "绛", "淡紫", "紫暗"];
  private hongdian: any[] = ["正常", "红点", "新鲜瘀点", "陈旧瘀点"];
  private yuban: any[] = ["无", "有"];
  private liewen: any[] = ["无", "浅", "深"];
  private chiheng: any[] = ["无", "轻", "中", "重"];
  private pangshou: any[] = ["瘦薄", "适中", "胖大"];
  private laoneng: any[] = ["娇嫩", "适中", "苍老"];
  private ifShowSeduDetail: boolean = false;
  private cPart: any = "LAB";
  private get t() {
    return this.tongue;
  }
  private set t(val) {
    this.$emit("update:tongue", val);
  }
  private get root() {
    return this.$refs.root as HTMLElement;
  }
  /**
   * @description 根据颜色返回色度值
   */
  private calBackColor(yanse) {
    switch (yanse) {
      case "淡":
        return "#F2CED0";
        break;
      case "淡红":
        return "#F7CACC";
        break;
      case "红":
        return "#E16E75";
        break;
      case "暗红":
        return "#B2444A";
        break;
      case "绛":
        return "#932C2C";
        break;
      case "淡紫":
        return "#C391BE";
        break;
      case "紫暗":
        return "#411951";
        break;
      default:
        return "#ffffff";
    }
  }
  /**
   * @description 打开色度值详情
   */
  private openSeduDetail() {
    this.ifShowSeduDetail = true;
  }
  /**
   * @description 删除局部舌色特征标注
   */
  private deleteJubushese() {
    this.$set(this.t, "局部舌色特征标注", {});
    this.$emit("deleteJubushese");
  }
  /**
   * @description 局部舌色特征标注主动滚动到顶
   */
  private jubusheseScrollToView() {
    const height = (this.$refs.fenbu as HTMLElement).offsetHeight;
    this.root.scroll({ top: height });
  }
  /**
   * @description 舌形特征标注主动滚动到顶
   */
  private tezhengbiaozhuScrollToView() {
    const height =
      (this.$refs.fenbu as HTMLElement).offsetHeight +
      (this.$refs.seduzhi as HTMLElement).offsetHeight;
    this.root.scroll({ top: height });
  }
  /**
   * @description 删除舌上红点
   */
  private deleteSheshanghongdian() {
    this.t["舌形特征标注"]["舌上红点参数"] = {};
    this.$emit("deleteSheshanghongdian");
  }
  /**
   * @description 删除某个瘀斑
   */
  private deleteYuban(index) {
    // this.t["舌形特征标注"]["瘀斑参数"]["瘀斑"].splice(index, 1);
    this.$emit("deleteYuban", index);
  }
  /**
   * @description 删除某个齿痕
   */
  private deleteChihen(index) {
    this.t["舌形特征标注"]["齿痕参数"]["齿痕"].splice(index, 1);
    this.$emit("deleteChihen", index);
  }
  /**
   * @description 删除某个裂纹
   */
  private deleteLiewen(index) {
    this.t["舌形特征标注"]["裂纹参数"]["裂纹"].splice(index, 1);
    this.$emit("deleteLiewen", index);
  }
  /**
   * @description 删除宽宽比的某项
   */
  private deleteKuankuanbi(part) {
    this.t["舌形特征标注"]["胖瘦参数"][part] = "";
    this.$emit("deleteKuankuanbi", part);
    this.t["舌形特征标注"]["胖瘦参数"]["宽宽比"] = "";
    if (
      !this.t["舌形特征标注"]["胖瘦参数"]["嘴角间距"] &&
      !this.t["舌形特征标注"]["胖瘦参数"]["舌间距"]
    ) {
      this.t["舌形特征标注"]["胖瘦参数"]["is_labeled"] = false;
    }
  }
  /**
   * @description 改变舌下脉络分布的值
   */
  private changeMailuo(key, value) {
    this.$set(this.t["舌下络脉分布"], key, value);
  }
  /**
   * @description 改变部分
   */
  private changeSeduPart(part) {
    this.cPart = part;
  }
  /**
   * @description 还原
   */
  private huanyuan() {
    this.t["舌形特征标注"]["舌上红点参数"] = {};
    this.t["舌形特征标注"]["瘀斑参数"] = {};
    this.t["舌形特征标注"]["齿痕参数"] = {};
    this.t["舌形特征标注"]["裂纹参数"] = {};
    this.t["舌形特征标注"]["胖瘦参数"] = {};
  }
}
